module.exports = __webpack_public_path__ + "static/media/lizhimaintanbiao1.48bc004f.png";